"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var router_1 = require("@angular/router");
var nav_bar_type_1 = require("./nav-bar/nav-bar-type");
var navigation_service_1 = require("./api/navigation.service");
var navigation_item_title_handler_service_1 = require("./navigation-item-title-handler.service");
var toggle_full_screen_service_1 = require("../shell-container/api/toggle-full-screen.service");
var navigation_message_service_1 = require("../../services/navigation-message-service");
var navigation_bar_state_1 = require("../header-bar/model/navigation-bar-state");
var platform_browser_1 = require("@angular/platform-browser");
var Subject_1 = require("rxjs/Subject");
var operators_1 = require("rxjs/operators");
var NavigationComponent = /** @class */ (function () {
    function NavigationComponent(configPath, navigationService, navigationMessageService, sessionDataProvider, router, titleService, navigationItemTitleHandlerService, toggleFullScreenService, eventBase) {
        var _this = this;
        this.configPath = configPath;
        this.navigationService = navigationService;
        this.navigationMessageService = navigationMessageService;
        this.sessionDataProvider = sessionDataProvider;
        this.router = router;
        this.titleService = titleService;
        this.navigationItemTitleHandlerService = navigationItemTitleHandlerService;
        this.toggleFullScreenService = toggleFullScreenService;
        this.eventBase = eventBase;
        this.isFullScreen = true;
        this.NavigationBarState = navigation_bar_state_1.NavigationBarState;
        this.pinState = navigation_bar_state_1.NavigationBarState.PINNED;
        this._navigationItemsByRouteLink = new Map();
        this.changeRouteDelay = 0;
        this._destroy$ = new Subject_1.Subject();
        this._navConfigFileUri = configPath + '/nav-config.json';
        this.loadData();
        this.eventBase.listen('page-management')
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function () { return _this.loadData(); });
        this.eventBase.listen('de-header-menu-clicked')
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function () { return _this.openByBurgerClick(); });
        this.toggleFullScreenService.isFullScreen()
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (value) { return _this.isFullScreen = value; });
    }
    NavigationComponent_1 = NavigationComponent;
    NavigationComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    NavigationComponent.prototype.openByBurgerClick = function () {
        if (this.pinState !== navigation_bar_state_1.NavigationBarState.PINNED) {
            this.pinState = navigation_bar_state_1.NavigationBarState.PINNED;
        }
        else {
            this.pinState = navigation_bar_state_1.NavigationBarState.UNPINNED;
        }
        this.eventBase.publish('navigation-bar-pin-state-changed', {
            pinState: this.pinState
        });
    };
    /**
     * Handles action when mouse moves into nav side bar.
     */
    NavigationComponent.prototype.hover = function () {
        if (this.pinState === navigation_bar_state_1.NavigationBarState.UNPINNED) {
            this.pinState = navigation_bar_state_1.NavigationBarState.OVERLAID;
        }
        this.eventBase.publish('navigation-bar-pin-state-changed', {
            pinState: this.pinState
        });
    };
    /**
     * Handles action when mouse moves out of nav side bar.
     */
    NavigationComponent.prototype.leave = function () {
        if (this.pinState !== navigation_bar_state_1.NavigationBarState.PINNED) {
            this.pinState = navigation_bar_state_1.NavigationBarState.UNPINNED;
        }
        this.eventBase.publish('navigation-bar-pin-state-changed', {
            pinState: this.pinState
        });
    };
    NavigationComponent.prototype.debouncedChangeRoute = function (item) {
        var _this = this;
        clearTimeout(this.changeRouteTimeout);
        this.changeRouteTimeout = window.setTimeout(function () {
            if (item.isExternal) {
                window.open(item.routeLink);
            }
            else {
                _this.router.navigate([item.routeLink]);
            }
        }, this.changeRouteDelay);
    };
    NavigationComponent.prototype.loadData = function () {
        var _this = this;
        this.navigationService.loadNavigationItems(this._navConfigFileUri).then(function () {
            _this.navigationService.getNavigationItems().then(function (items) {
                _this.navigationItems = items;
                _this._navigationItemsByRouteLink = NavigationComponent_1.collectNavigationItemsByRouteLink(items);
                _this.router.events
                    .filter(function (event) { return event instanceof router_1.NavigationStart; })
                    .pipe(operators_1.takeUntil(_this._destroy$))
                    .subscribe(function (event) {
                    if (event.url === '/') {
                        _this.navigateToPublicRouterLink(items);
                        return;
                    }
                    _this.unselectNavigationItem();
                    _this.findNavigationItemAndSelect(event.url);
                });
                if (_this.router.url === '/') {
                    _this.navigateToPublicRouterLink(items);
                }
                else {
                    _this.findNavigationItemAndSelect(_this.router.url);
                }
                // init routes for resolving page title after navigation
                _this.navigationItemTitleHandlerService.initRoutes(items);
                // set current page title
                _this.navigationItemTitleHandlerService.getCurrentRouteTitle()
                    .pipe(operators_1.takeUntil(_this._destroy$))
                    .subscribe(function (title) { return _this.titleService.setTitle(title); });
                // subscribe to sequence navigation events to change page title
                _this.navigationItemTitleHandlerService.subscribeToNavigationChanges()
                    .pipe(operators_1.takeUntil(_this._destroy$))
                    .subscribe(function (title) { return _this.titleService.setTitle(title); });
            });
            _this.eventBase.listen('navigation-bar-pin-state-changed')
                .pipe(operators_1.takeUntil(_this._destroy$))
                .subscribe(function (event) {
                _this.pinState = event.data.pinState;
            });
        });
    };
    /**
     * Navigate on first nav item page, marked as default.
     * If default item does not exists, then navigate to first item page.
     */
    NavigationComponent.prototype.navigateToPublicRouterLink = function (navItems) {
        var _this = this;
        var existDefault = navItems.some(function (section) {
            return section.children.some(function (groupOrItem) {
                if (groupOrItem.navBarType === nav_bar_type_1.NavBarType.ITEM) {
                    if (Boolean(groupOrItem.isDefault)) {
                        _this.router.navigate([groupOrItem.routeLink]);
                        return true;
                    }
                }
                return groupOrItem.children.some(function (item) {
                    if (Boolean(item.isDefault)) {
                        _this.router.navigate([item.routeLink]);
                        return true;
                    }
                    return false;
                });
            });
        });
        if (!existDefault) {
            navItems.some(function (section) {
                return section.children.some(function (groupOrItem) {
                    if (groupOrItem.navBarType === nav_bar_type_1.NavBarType.ITEM) {
                        _this.router.navigate([groupOrItem.routeLink]);
                        return true;
                    }
                    return groupOrItem.children.some(function (item) {
                        _this.router.navigate([item.routeLink]);
                        return true;
                    });
                });
            });
        }
    };
    NavigationComponent.prototype.onNavigationItemClick = function (item) {
        var navigationItem = this._navigationItemsByRouteLink.get(item.routeLink);
        if (!item.isExternal) {
            this.unselectNavigationItem();
            this.selectNavigationItem(navigationItem);
        }
        this.debouncedChangeRoute(item);
        this.foldNavigationBarForMobileDevices();
    };
    NavigationComponent.prototype.foldNavigationBarForMobileDevices = function () {
        if (window.innerWidth <= 750) {
            this.pinState = navigation_bar_state_1.NavigationBarState.UNPINNED;
            this.eventBase.publish('navigation-bar-pin-state-changed', {
                pinState: this.pinState
            });
        }
    };
    NavigationComponent.prototype.findNavigationItemAndSelect = function (url) {
        var urlPathName = NavigationComponent_1.getUrlPathName(url);
        var navigationItem;
        // slicing from last slash till navigation item matches, e.g. slicing `page-management/pages/4775` up to 'page-management'
        while (true) {
            navigationItem = this._navigationItemsByRouteLink.get(urlPathName);
            if (navigationItem) {
                this.selectNavigationItem(navigationItem);
                break;
            }
            else {
                var sliced = NavigationComponent_1.sliceLastSlashPart(urlPathName);
                if (sliced === urlPathName) {
                    break;
                }
                urlPathName = sliced;
            }
        }
    };
    NavigationComponent.prototype.selectNavigationItem = function (item) {
        item.self.isSelected = true;
        var ownGroup = item.ownGroup;
        if (ownGroup) {
            ownGroup.isSelected = true;
        }
        this._selectedItem = item;
    };
    NavigationComponent.prototype.unselectNavigationItem = function () {
        if (this._selectedItem) {
            this._selectedItem.self.isSelected = false;
            var ownGroup = this._selectedItem.ownGroup;
            if (ownGroup) {
                ownGroup.isSelected = false;
            }
            this._selectedItem = null;
        }
    };
    NavigationComponent.getUrlPathName = function (url) {
        var index = url.search(/[?#]/);
        if (index === -1) {
            return url;
        }
        else {
            return url.substring(0, index);
        }
    };
    NavigationComponent.sliceLastSlashPart = function (url) {
        var index = url.lastIndexOf('/');
        if (index === -1) {
            return url;
        }
        else {
            return url.substring(0, index);
        }
    };
    NavigationComponent.collectNavigationItemsByRouteLink = function (items) {
        var navigationItemsByRouteLink = new Map();
        items.forEach(function (section) {
            section.children.forEach(function (navItem) {
                if (navItem.navBarType === nav_bar_type_1.NavBarType.GROUP) {
                    navItem.children.forEach(function (item) {
                        navigationItemsByRouteLink.set(item.routeLink, {
                            self: item,
                            ownGroup: navItem
                        });
                    });
                }
                else if (navItem.navBarType === nav_bar_type_1.NavBarType.ITEM) {
                    navigationItemsByRouteLink.set(navItem.routeLink, {
                        self: navItem,
                        ownGroup: null
                    });
                }
            });
        });
        return navigationItemsByRouteLink;
    };
    var NavigationComponent_1;
    NavigationComponent = NavigationComponent_1 = __decorate([
        core_1.Component({
            
            selector: 'sis-shell-nav-block',
            template: require('./navigation.component.html'),
            styles: [require('./navigation.component.css')]
        })
        /* tslint:disable:rxjs-no-ignored-subscription */
        ,
        __param(0, core_1.Inject('configPath')),
        __metadata("design:paramtypes", [String, navigation_service_1.NavigationService,
            navigation_message_service_1.NavigationMessageService,
            idm_session_data_provider_api_js_1.SessionDataProvider,
            router_1.Router,
            platform_browser_1.Title,
            navigation_item_title_handler_service_1.NavigationItemTitleHandlerService,
            toggle_full_screen_service_1.ToggleFullScreenService,
            idm_session_data_provider_api_js_1.EventBase])
    ], NavigationComponent);
    return NavigationComponent;
}());
exports.NavigationComponent = NavigationComponent;
//# sourceMappingURL=navigation.component.js.map